// extracted by mini-css-extract-plugin
export var addressFields = "_m9-0";
export var animationContainer = "_m9-1";
export var footer = "_m9-2";
export var lineItems = "_m9-3";
export var modalContent = "_m9-4";
export var orderName = "_m9-5";
export var strong = "_m9-6";
export var warning = "_m9-7";